module.exports = "\n<app-body *ngIf=\"http.paginaactual === 'login'\"></app-body>\n<app-docs *ngIf=\"http.paginaactual === 'docs'\"></app-docs>\n<app-datosusuario *ngIf=\"http.paginaactual === 'qrs'\"></app-datosusuario>\n<app-datosaf *ngIf=\"http.paginaactual === 'editarQr'\"></app-datosaf>\n<app-albaranes *ngIf=\"http.paginaactual === 'albaranes'\"></app-albaranes>\n<app-entrega *ngIf=\"http.paginaactual === 'entrega'\"></app-entrega>\n\n"


//////////////////
// WEBPACK FOOTER
// /Users/usuario/Desktop/Angular/Urbanos/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main